import { useEffect } from 'react';
import { PlanEditorScreen } from '../screens/editor/PlanEditorScreen';
import { LedgerScreen } from '../screens/ledger/LedgerScreen';
import { ResultsScreen } from '../screens/results/ResultsScreen';
import { LeftNav } from './LeftNav';
import { useRoute } from './routes';
import { useAppStore } from './store';
import { TopBar } from './TopBar';
import './app.css';

/**
 * The App shell (PLAN.md M7): a fixed left-nav (ProjectionLab-style section navigation) + a top bar,
 * with the active screen in the content column. The three screens — Plan editor, Results dashboard,
 * Ledger drill-down — are switched by the hash router. The shell itself carries the orchestrated
 * load reveal; each screen owns its own staggered card reveals.
 *
 * On mount it hydrates the editor from the active plan store (the most-recently-saved plan, if any),
 * so a returning user lands on their own plan; with no saved plan the seeded sample plan stays.
 */
export function App(): React.ReactElement {
  const route = useRoute();
  const hydrate = useAppStore((s) => s.hydrate);
  useEffect(() => {
    void hydrate();
  }, [hydrate]);
  return (
    <div className="shell">
      <LeftNav />
      <div className="shell__main">
        <TopBar />
        <main className="shell__content">
          {route === 'editor' && <PlanEditorScreen />}
          {route === 'results' && <ResultsScreen />}
          {route === 'ledger' && <LedgerScreen />}
        </main>
      </div>
    </div>
  );
}
